<template>
<div>
  <div class="title-bar title-h3">
    {{ title }} WAS 인스턴스 목록
  </div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <el-button :disabled="!checkChangeFlag" class="mr-r4" @click="deleteInstances">삭제</el-button>
    </div>
    <div class="vertical-center-box">
      <el-button :disabled="!checkChangeFlag" type="secondary" @click="openChangePopup" class="mr-r4">티어변경</el-button>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool" />
    </div>
  </el-row>
  <el-row class="mr-b20">
    <el-table-wrapper v-loading="isLoading" ref="instanceTable" :show-search-tool="showSearchTool" :total="total" row-class-name="c-dblclick" pagination :show-custom-header="true"
    :data="dataList" :columns="wasListColumns" :column-default="columnDefault" @condition-change="loadInstatnceList" @selection-change="instanceSelectionChange" @cell-dblclick="onDbclickRow">
      <template slot-scope="scope" slot="status-slot">
        <i v-if="scope.row.status == 'Y'" class="fas fa-circle text-mini state-normal"/>
        <i v-else class="fas fa-circle state-none" />
      </template>
    </el-table-wrapper>
  </el-row>
  <w-group-change-popup ref="groupChangePopup" current-tree-type="instance" :selected-config-treekey="currentNode.treeKey" :selection-nodes="instanceSelection" @reloadData="reloadGroup" />
  <w-update-instance-popup ref="instancePopup" @reloadData="loadInstatnceList" />
</div>
</template>

<script>
import { isNil, isEmpty } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';
import WGroupChangePopup from '../components/popup/GroupChangePopup';
import WUpdateInstancePopup from '../components/popup/UpdateInstancePopup';

export default {
  name: 'WInstanceSettingView',
  components: {
    WGroupChangePopup,
    WUpdateInstancePopup,
  },
  props: {
    currentNode: {
      type: Object,
    },
  },
  data() {
    return {
      columnDefault,
      instanceSelection: [],
      checkChangeFlag: false,
      showSearchTool: false,
      dataList: null,
      isLoading: false,
      total: 0,
      wasListColumns: [
        {
          type: 'selection',
        },
        {
          prop: 'status',
          label: '상태',
          align: 'center',
          headerAlign: 'center',
          width: 60,
          sortable: true,
          scopedSlot: 'status-slot',
        },
        {
          prop: 'objName',
          label: '이름',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'uniqueKey',
          label: '고유키',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'agentManagerName',
          label: '에이전트 매니저 이름',
          searchable: true,
          sortable: true,
        },
      ],
    };
  },
  computed: {
    title() {
      if (isEmpty(this.currentNode)) {
        return null;
      }
      return this.currentNode.tierId ? `[${this.currentNode.tierName}]` : null;
    },
    isNodeFlag() {
      return this.currentNode.type === 'group';
    },
  },
  watch: {
    currentNode: {
      immediate: true,
      handler(currentNode) {
        if (isEmpty(currentNode) || currentNode.type !== 'group') {
          return;
        }

        this.$nextTick(() => {
          this.loadInstatnceList();
        });
      },
    },
  },
  methods: {
    getTableValueAfterCheckEmpty(row, column, value) {
      return isEmpty(value) ? EMPTY_TEXT : value;
    },
    /**
     * [loadInstatnceList 인스턴스 리스트를 가져온다. 리스트의 첫번째 항목을 선택하도록 한다.]
     * @author yelim
     */
    loadInstatnceList() {
      if (!isNil(this.currentNode.tierId)) {
        this.isLoading = true;

        const tableParams = this.$refs.instanceTable.getParameter();
        ApmSettingAPI.getInstanceSetList({ tierId: this.currentNode.tierId, ...tableParams }).then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.dataList = response.data.data;
            this.total = response.data.total;
          } else {
            this.dataList = [];
            this.total = 0;
          }
        });
      }
    },
    /**
     * [instanceSelectionChange 선택된 인스턴스 리스트를 저장한다.]
     * @author yelim
     */
    instanceSelectionChange(row) {
      this.instanceSelection = row;
      if (this.isNodeFlag && row.length > 0) {
        this.checkChangeFlag = true;
      } else {
        this.checkChangeFlag = false;
      }
    },
    /**
     * [openChangePopup 노드가 속한 그룹의 정보를 바꾸기 위한 팝업 오픈]
     * @author yelim
     */
    openChangePopup() {
      this.$refs.groupChangePopup.open();
    },
    /**
     * [deleteInstances 선택한 인스턴스 항목들을 삭제한다.]
     * @author yelim
     */
    deleteInstances() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        ApmSettingAPI.deleteInstances(this.instanceSelection).then((response) => {
          if (response.data.success) {
            this.reloadGroup();
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '인스턴스', response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '인스턴스', false));
        });
      }).catch(() => {});
    },
    reloadGroup() {
      this.loadInstatnceList();
      this.$emit('reloadTree');
    },
    /**
     * 인스턴스 이름 변경 팝업창을 띄운다.
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onDbclickRow(record) {
      const info = {
        tierName: this.currentNode.tierName,
        ...record,
      };
      this.$refs.instancePopup.open(info);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/instance/InstanceSettingView.vue